export default __webpack_public_path__ + "377a2d5ff882454085da5fb2e9b87399.svg";